import { type FC, memo } from "react";

import { InformationPage } from "~/common/components/informationPage/InformationPage";
import { IMG_EMPTY_STATE } from "~/utils/url/staticResources";
import { Trans, useTranslation as useTranslation } from "react-i18next";

interface AccountSelectionNoAccountsProps {
  onSelectPersonalAccount: () => void;
}

const AccountSelectionNoAccounts: FC<AccountSelectionNoAccountsProps> = ({ onSelectPersonalAccount }) => {
  const { t } = useTranslation();

  return (
    <InformationPage
      title={
        <div className="mt-60 mb-3 f-center col-5">
          <div className="display-small">
            <Trans i18nKey={"accountSelectionPage.noAccounts.headline"} />
          </div>
        </div>
      }
      btnSetup={{
        onClick: onSelectPersonalAccount,
        label: t("accountSelectionPage.noAccounts.button"),
      }}
      imageSrc={IMG_EMPTY_STATE}
    />
  );
};

export default memo(AccountSelectionNoAccounts);
